<i18n>
{
  "fr": {
    "BirthdateRepeatableField": {
      "add": "Ajouter un anniversaire…"
    }
  }
}
</i18n>

<template>
  <div class="birthdate-repeatable-form">
    <BirthdateForm
      v-for="(form, index) in birthdates"
      :key="index"
      v-model="birthdates[index]"
      :form="form"
      :field-name="`birthdates[${index}]`"
      :gender-options="genderOptions"
      :relationship-options="relationshipOptions"
      :server-errors="serverErrors[index] || null"
      @removeForm="removeForm(index)"
    />

    <button
      v-if="birthdates.length < limit"
      class="birthdate-repeatable-form__add"
      type="button"
      @click="addForms"
    >
      {{ $t('BirthdateRepeatableField.add') }}
    </button>
  </div>
</template>

<script>
import BirthdateForm from './BirthdateForm.vue';

export default {
  name: 'BirthdateRepeatableField',
  components: {
    BirthdateForm,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    genderOptions: {
      type: Object,
      default: () => {},
    },
    relationshipOptions: {
      type: Object,
      default: () => {},
    },
    limit: {
      type: Number,
      required: true,
    },
    serverErrors: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      birthdates: this.value,
    };
  },
  methods: {
    addForms() {
      if (this.birthdates.length <= this.limit) {
        this.birthdates.push({
          first_name: '',
          birthdate: '',
          gender: Object.keys(this.genderOptions)[0],
          relationship: Object.keys(this.relationshipOptions)[0],
        });
      }
    },
    /**
     * @param {number} index
     */
    removeForm(index) {
      this.birthdates.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.birthdate-repeatable-form {
  display: flex;
  flex-direction: column;

  &__add {
    margin-top: 1em;
    border: none;
    background: none;
    color: $color-default-link;
    text-decoration: underline;
    font-size: 0.875em;
    align-self: flex-start;
  }
}
</style>
